import React, { useContext, useState } from "react";
import { Button, Grid, Paper, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";

import config from "../../../dashboard-config";
import BigLabelTextField from "../../StyledComponents/BigLabelTextField";
import { SessionContext } from "../../../context/SessionContext";
import APIProductInfo from "../APIProductInfo";
import APIProducts from "../APIProducts";
import { UserAuth, User } from "../../../shared-types/User";

const useStyles = makeStyles(theme => {
  return {
    checkIcon: {
      color: "#80FF80",
      marginRight: "10px"
    },
    page: {
      width: "100vw",
      height: "81vh",
      padding: theme.spacing(4)
    }
  };
});

type APIAccessPageProps = {
  user: User;
};

const APIAccessPage: React.FC<APIAccessPageProps> = ({ user }) => {
  const classes = useStyles();
  const { selectedApiCard, currentTrial } = useContext(SessionContext);
  const [profileInfo, setProfileInfo] = useState<UserAuth>(
    JSON.parse(localStorage.getItem("sofar-user") || "{}")
  );
  const regenerateToken = () => {
    fetch(`${config.wavefleetUrl}/users/${profileInfo.username}/tokens/`, {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/x-www-form-urlencoded",
        token: profileInfo.token
      })
    })
      .then(res => res.json())
      .then(res => {
        localStorage.setItem("sofar-user", JSON.stringify(res));
        setProfileInfo(res);
      });
  };

  const trialStatusText =
    currentTrial?.hasNotStartedAPITrial === true
      ? "Trial not started"
      : "API Trial is active!";

  return (
    <Paper>
      <div className={classes.page}>
        <Grid
          justify="flex-start"
          alignItems="flex-start"
          spacing={3}
          container
        >
          <Grid xs={1} lg={2} item></Grid>
          <Grid sm={4} md={5} lg={4} container spacing={2} item>
            <Grid item spacing={1} container>
              <Grid item>
                <BigLabelTextField
                  fullWidth
                  value={profileInfo.token}
                  label="API Token"
                />
              </Grid>
              <Grid item spacing={1} container>
                <Grid item>
                  <Button
                    variant="contained"
                    onClick={() => {
                      navigator.clipboard.writeText(profileInfo.token);
                    }}
                  >
                    Copy Token
                  </Button>
                </Grid>
                <Grid item>
                  <Button variant="outlined" onClick={regenerateToken}>
                    Regenerate Token
                  </Button>
                </Grid>
                <Grid item></Grid>
              </Grid>
            </Grid>
            <Grid item spacing={1} container>
              <Grid item>
                <BigLabelTextField
                  fullWidth
                  value={trialStatusText}
                  label="Trial Status"
                />
              </Grid>
              <Grid item spacing={1} container>
                <Grid item>
                  {currentTrial?.hasNotStartedAPITrial && (
                    <Button
                      variant="contained"
                      component={Link}
                      to="/api-trial"
                      // waiting for Endpoint to wire up START TRIAL
                      // onClick={() => {}}
                    >
                      Start Trial
                    </Button>
                  )}
                </Grid>
              </Grid>
            </Grid>
            <Grid item container>
              <Typography variant="h6" gutterBottom>
                Products
              </Typography>
              <APIProducts />
            </Grid>
          </Grid>

          <Grid sm={6} md={5} lg={4} direction="row" item container>
            {selectedApiCard.section && (
              <APIProductInfo
                title={selectedApiCard.section.title}
                body={selectedApiCard.section.body}
                link={selectedApiCard.section.link}
                list={selectedApiCard.section.list}
                priceData={selectedApiCard.section.priceData}
                priceCalls={selectedApiCard.section.priceCalls}
                userEmail={user.email}
              />
            )}
          </Grid>
          <Grid sm={1} md={2} lg={1} item></Grid>
        </Grid>
      </div>
    </Paper>
  );
};

export default APIAccessPage;
